var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "text-center mb-6" }, [
        _vm._v(" " + _vm._s(_vm.$t("roomWizard.displaySettings")) + " ")
      ]),
      _c(
        "v-form",
        {
          ref: "displayForm",
          attrs: { onSubmit: "return false;" },
          model: {
            value: _vm.valid,
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        },
        [
          _c("v-select", {
            staticClass: "mb-4",
            attrs: {
              outlined: "",
              items: _vm.displayModeOptions,
              label: _vm.$t("policiesFields.DeviceDisplayMode")
            },
            model: {
              value: _vm.config.deviceDisplayMode,
              callback: function($$v) {
                _vm.$set(_vm.config, "deviceDisplayMode", $$v)
              },
              expression: "config.deviceDisplayMode"
            }
          }),
          _c(
            "div",
            { staticClass: "d-flex justify-space-between my-8" },
            [
              !_vm.first && !_vm.second
                ? _c("va-button", {
                    staticClass: "mr-4",
                    attrs: {
                      color: "secondary",
                      type: "outline",
                      cta: _vm.$t("roomWizard.prev")
                    },
                    on: { click: _vm.onBack }
                  })
                : _c("v-spacer"),
              _c("va-button", {
                attrs: {
                  disabled: !_vm.valid,
                  loading: _vm.loading,
                  cta: _vm.$t("roomWizard.next")
                },
                on: { click: _vm.onFinish }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }